import React, { useState } from 'react';
import './VPSNetherlands.css';

const VPSNetherlands = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const plans = [
    {
      tier: 'استارتر',
      price: '۲۸۰',
      unit: 'هزار تومان / ماه',
      cpu: '2 Core',
      ram: '۴ GB',
      storage: '۵۰ GB NVMe',
      features: ['لوکیشن هلند', 'پینگ پایین', 'پهنای باند بالا', 'پشتیبانی ۲۴/۷'],
      popular: false,
    },
    {
      tier: 'پیشرفته',
      price: '۴۸۰',
      unit: 'هزار تومان / ماه',
      cpu: '4 Core',
      ram: '۸ GB',
      storage: '۱۰۰ GB NVMe',
      features: ['لوکیشن هلند', 'پینگ پایین', 'پهنای باند بالا', 'پشتیبانی ۲۴/۷', 'IP اختصاصی'],
      popular: true,
    },
    {
      tier: 'حرفه‌ای',
      price: '۷۸۰',
      unit: 'هزار تومان / ماه',
      cpu: '8 Core',
      ram: '۱۶ GB',
      storage: '۲۰۰ GB NVMe',
      features: ['لوکیشن هلند', 'پینگ پایین', 'پهنای باند بالا', 'پشتیبانی ۲۴/۷', 'IP اختصاصی', 'اولویت پشتیبانی'],
      popular: false,
    },
  ];

  const features = [
    {
      icon: '🇳🇱',
      title: 'لوکیشن استراتژیک در هلند',
      desc: 'VPS هلند در دیتاسنترهای معتبر و پیشرفته هلند قرار دارد که بهترین پینگ را برای کاربران اروپایی و خاورمیانه فراهم می‌کند. هلند به عنوان یکی از بهترین مراکز داده اروپا شناخته می‌شود.',
    },
    {
      icon: '⚡',
      title: 'پهنای باند بالا و سرعت عالی',
      desc: 'VPS هلند با پهنای باند بالا و اتصال به شبکه‌های جهانی، سرعت بارگذاری فوق‌العاده‌ای را برای وب‌سایت‌های بین‌المللی فراهم می‌کند. مناسب برای وب‌سایت‌های پربازدید و اپلیکیشن‌های سنگین.',
    },
    {
      icon: '🛡️',
      title: 'امنیت و پایداری بالا',
      desc: 'دیتاسنترهای هلند با استانداردهای امنیتی بالا و سیستم‌های پشتیبانی پیشرفته، پایداری و امنیت فوق‌العاده‌ای را برای سرور شما فراهم می‌کنند.',
    },
    {
      icon: '🌍',
      title: 'مناسب برای کسب‌وکارهای بین‌المللی',
      desc: 'VPS هلند با دسترسی عالی به شبکه‌های اروپا، آمریکا و خاورمیانه، گزینه‌ای ایده‌آل برای کسب‌وکارهای بین‌المللی و وب‌سایت‌های با مخاطب جهانی است.',
    },
  ];

  const faqs = [
    {
      q: 'VPS هلند چه مزایایی نسبت به سایر لوکیشن‌ها دارد؟',
      a: 'VPS هلند به دلیل موقعیت استراتژیک در قلب اروپا، پینگ بسیار خوبی برای کاربران اروپایی و خاورمیانه دارد. دیتاسنترهای هلند از استانداردهای امنیتی بالایی برخوردار هستند و پهنای باند بالا و پایداری عالی را ارائه می‌دهند. همچنین هلند به عنوان یکی از بهترین مراکز داده دنیا شناخته می‌شود و بسیاری از شرکت‌های بزرگ بین‌المللی از دیتاسنترهای هلند استفاده می‌کنند.',
    },
    {
      q: 'آیا VPS هلند برای وب‌سایت‌های فارسی مناسب است؟',
      a: 'بله، VPS هلند با پینگ مناسب برای ایران و خاورمیانه، گزینه‌ای عالی برای وب‌سایت‌های فارسی با مخاطبان ایرانی و بین‌المللی است. سرعت بارگذاری برای کاربران ایرانی بسیار خوب است و در عین حال، وب‌سایت شما برای کاربران اروپایی و سایر نقاط جهان نیز سرعت عالی دارد.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>VPS هلند | خرید سرور مجازی هلند با بهترین قیمت | افرسل</h1>
        <p>خرید VPS هلند با سرورهای NVMe، پینگ پایین و پشتیبانی ۲۴ ساعته. سرور مجازی هلند مناسب برای وب‌سایت‌های بین‌المللی، فروشگاه‌های آنلاین و اپلیکیشن‌های نیازمند پهنای باند بالا.</p>
        <meta name="description" content="خرید VPS هلند با بهترین قیمت از افرسل. سرور مجازی هلند با NVMe، پینگ پایین، پهنای باند بالا و پشتیبانی ۲۴/۷." />
      </div>

      <section className="vps-netherlands-hero">
        <div className="vps-netherlands-hero-bg"></div>
        <div className="wrap">
          <div className="vps-netherlands-hero-content">
            <div className="vps-netherlands-badge">
              <span className="pulse-dot"></span>
              🇳🇱 VPS هلند
            </div>
            <h1 className="vps-netherlands-hero-title">
              سرور مجازی <em>هلند</em>
            </h1>
            <p className="vps-netherlands-hero-desc">
              VPS هلند با سرورهای NVMe، پینگ پایین و پهنای باند بالا.
              مناسب برای وب‌سایت‌های بین‌المللی، فروشگاه‌های آنلاین و اپلیکیشن‌های نیازمند پهنای باند بالا.
              دیتاسنترهای معتبر هلند با بهترین کیفیت و پایداری.
            </p>
            <div className="vps-netherlands-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۳</span>
                <span className="stat-label">پلن مختلف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">هلند</span>
                <span className="stat-label">لوکیشن</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="vps-netherlands-plans">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پلن‌های VPS هلند</span>
            <h2 className="sec-h">پلن <em>مناسب</em> پروژه خود را انتخاب کنید</h2>
            <p className="sec-p">پلن‌های متنوع VPS هلند با قیمت‌های رقابتی و منابع کافی برای هر نوع پروژه بین‌المللی.</p>
          </div>
          <div className="vps-netherlands-plans-grid">
            {plans.map((plan, i) => (
              <div key={i} className={`vps-netherlands-plan ${plan.popular ? 'popular' : ''}`}>
                {plan.popular && <span className="vps-netherlands-popular-badge">پرفروش‌ترین</span>}
                <div className="vps-netherlands-plan-tier">{plan.tier}</div>
                <div className="vps-netherlands-plan-price">
                  <span className="vps-netherlands-plan-num">{plan.price}</span>
                  <span className="vps-netherlands-plan-unit">{plan.unit}</span>
                </div>
                <div className="vps-netherlands-plan-specs">
                  <div><span>🖥️</span> {plan.cpu}</div>
                  <div><span>💾</span> {plan.ram}</div>
                  <div><span>📀</span> {plan.storage}</div>
                </div>
                <ul className="vps-netherlands-plan-features">
                  {plan.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <button className="vps-netherlands-order-btn" onClick={() => scrollTo('contact')}>سفارش دهید</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-netherlands-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای VPS هلند</span>
            <h2 className="sec-h">چرا <em>VPS هلند</em> با افرسل؟</h2>
            <p className="sec-p">VPS هلند با بهترین امکانات و خدمات برای کسب‌وکارهای بین‌المللی.</p>
          </div>
          <div className="vps-netherlands-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="vps-netherlands-feature-card">
                <span className="vps-netherlands-feature-icon">{feature.icon}</span>
                <h3 className="vps-netherlands-feature-title">{feature.title}</h3>
                <p className="vps-netherlands-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-netherlands-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
          </div>
          <div className="vps-netherlands-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="vps-netherlands-faq-item">
                <div className="vps-netherlands-faq-q">{faq.q}</div>
                <div className="vps-netherlands-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-netherlands-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              VPS <em>هلند</em> را همین حالا خریداری کنید
            </h2>
            <p className="cta-desc">
              با خرید VPS هلند، از سرعت بالا، پهنای باند عالی و پشتیبانی ۲۴ ساعته بهره‌مند شوید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>خرید VPS</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VPSNetherlands;
